import { ApiResourceFactory } from '../api.resource.factory'
import { GridModel, GridRequestModel, EntityModel, LocationModel, OperatorModel, FieldNameValueModel, NotificationModel, SecurityActivityModel, SecurityChangeModel, ResponseDeleteModel, FormValuesModel, PasswordResetModel, PasswordResetResponseModel, ResponseListModel, DepositoryContentModel, OpResult } from '../api.models'
import { CommonHelper } from '../../../helpers/common-helper'
import { OperatorLayoutSettings } from '../../../helpers/operator-layout-settings'
import { OpLocationEquipment } from '../../../models/core/op-location-equipment-old'

export interface IUsersService {
    getUsers(req: GridRequestModel, state?: any): ng.IPromise<GridModel>
    getUser(id: number, state?: any): ng.IPromise<OperatorModel>
    getUserToEdit(id: number, state?: any): ng.IPromise<OperatorModel>
    saveUser(req): ng.IPromise<OperatorModel>
    deleteUser(id: number): ng.IPromise<ResponseDeleteModel>
    submitActivities(model: SecurityChangeModel): ng.IPromise<OperatorModel>
    submitRoles(model: SecurityChangeModel): ng.IPromise<OperatorModel>
    changeNotification(model: NotificationModel): ng.IPromise<OperatorModel>
    changeReferenceObject(model: SecurityActivityModel): ng.IPromise<OperatorModel>
    changeAllowedDistributors(model: FormValuesModel): ng.IPromise<ResponseListModel<number>>
    changePassword(model: PasswordResetModel): ng.IPromise<PasswordResetResponseModel>
    getLoggedOperator(): ng.IPromise<OperatorModel>
    getOperatorDepositoryContent(id: number): ng.IPromise<OpLocationEquipment[]>
}

export class UsersService implements IUsersService {
    constructor(private apiResource: ApiResourceFactory) { }

    getUsers(req: GridRequestModel, state: any = {}) {
        var get = this.apiResource.users.query
        state.request = get(req)
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    getUser(id: number, state: any = {}) {
        var get = this.apiResource.users.get
        state.request = get({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state, false, rej.data.Message))
    }

    getUserToEdit(id: number, state: any = {}) {
        var getUserToEdit: ng.resource.IResourceMethod<ng.resource.IResource<EntityModel>> = this.apiResource.users['getUserToEdit']
        state.request = getUserToEdit({ id: id })
        return state.request.$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }

    saveUser(req): ng.IPromise<OperatorModel> {
        return this.apiResource.users.save(req).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    deleteUser(id: number): ng.IPromise<ResponseDeleteModel> {
        return this.apiResource.users.delete({ id: id }).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch<any>(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    submitActivities(model: SecurityChangeModel) {
        return this.apiResource.users['submitActivities'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    submitRoles(model: SecurityChangeModel) {
        return this.apiResource.users['submitRoles'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    changeNotification(model: NotificationModel) {
        return this.apiResource.users['changeNotification'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    changeReferenceObject(model: SecurityActivityModel) {
        return this.apiResource.users['changeReferenceObject'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    changeAllowedDistributors(model: FormValuesModel) {
        return this.apiResource.users['changeAllowedDistributors'](model).$promise.then(result => {
            CommonHelper.checkResultError(result)
            return (<any>result).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    changePassword(model: PasswordResetModel): ng.IPromise<PasswordResetResponseModel> {
        return this.apiResource.users['changePassword'](model).$promise.then(r => {
            CommonHelper.checkResultError(r)
            return (<any>r).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getLoggedOperator(): ng.IPromise<OperatorModel> {
        return this.apiResource.users['getLoggedOperator']().$promise.then(user => {
            CommonHelper.checkResultError(user)
            return (<any>user).toJSON()
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status))
    }

    getOperatorDepositoryContent(id: number, state: any = {}) {
        var getOperatorDepositoryContent = this.apiResource.users['getOperatorDepositoryContent']
        state.request = getOperatorDepositoryContent({ id: id })
        return state.request.$promise.then((response: OpResult) => {
            var result = response.result.map(r => new OpLocationEquipment(r))
            CommonHelper.checkResultError(response)
            return result
        }).catch(rej => CommonHelper.handleRejection(this.apiResource, rej.status, state))
    }
}
